export const rtlLocales = ['he', 'ar-EG'] as const;

export type I18nLanguageSource = {
  language?: string;
  resolvedLanguage?: string;
};

const getStoredLanguage = (): string | undefined => {
  if (typeof globalThis.localStorage === 'undefined') {
    return undefined;
  }

  const stored = globalThis.localStorage.getItem('i18nextLng')?.trim();
  return stored || undefined;
};

export const getResolvedLanguage = (i18n: I18nLanguageSource): string => {
  const language = i18n.language?.trim();
  if (language) {
    return language;
  }

  const resolvedLanguage = i18n.resolvedLanguage?.trim();
  if (resolvedLanguage) {
    return resolvedLanguage;
  }

  return getStoredLanguage() || 'en';
};

export const isRtlLanguage = (
  language: string,
  locales: readonly string[] = rtlLocales,
): boolean =>
  locales.includes(language) ||
  locales.some((locale) => language.startsWith(`${locale}-`));
